module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "extended": !_vm.isBasePage
    }
  }, [_c('v-toolbar-title', [_vm._v("\n      " + _vm._s(_vm.$route.name) + "\n    ")]), _vm._v(" "), (!_vm.isBasePage) ? _c('template', {
    slot: "extension"
  }, [_c('v-btn', {
    staticClass: "pl-0",
    attrs: {
      "to": "/integrations/",
      "small": "",
      "flat": "",
      "text": ""
    }
  }, [_vm._v("Integrations")]), _vm._v(" "), _c('v-icon', [_vm._v("chevron_right")]), _vm._v("\n      " + _vm._s(_vm.$route.name) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$route.meta.installHelp) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "target": "_blank",
      "color": "info",
      "href": _vm.$route.meta.installHelp
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n      Help "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": "",
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e()], 2), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3472bf68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/index.vue
// module id = 1652
// module chunks = 5